import styles from "./LoaderForAuth.module.css";

const LoaderForAuth = () => {
  return (
    <div className={`${styles["loader-5"]} ${styles["center"]}`}>
      <span></span>
    </div>
  );
};

export default LoaderForAuth;
